import React from 'react';
import $ from 'jquery';
import StonesStore from './../stores/stonesStore';

export default class HomeButton extends React.Component {

  componentWillMount() {
    $(document).bind('click touchstart', this.bindDocumentClick);
  }

  componentWillUnmount() {
    $(document).unbind('click touchstart', this.bindDocumentClick);
  }

  handleHomeMenuClick = (e) => {
    const menu     = $('.home-menu'),
      // header       = $('.header-bar'),
      stoneWrapper = $('.stone-filters-wrapper');
    menu.length && menu.addClass('home-menu--opened');
    // header.addClass('header-bar--home-opened');
    // header.hasClass('open') && header.removeClass('open');
    // stoneWrapper.hasClass('stone-filters-wrapper') && stoneWrapper.removeClass('open');
  };

  bindDocumentClick = (e) => {
    const homemenu = $('.home-menu');
    if (homemenu.hasClass('home-menu--opened') && !homemenu.is(e.target) && (homemenu.has(e.target).length === 0) && !$(e.target).closest('.home').length) {
      this.removeActiveMenu();
    }
  };

  removeActiveMenu =() => {
    const header = $('.header-bar'),
      homemenu = $('.home-menu--opened');
    homemenu.removeClass('home-menu--opened');
    // header.removeClass('header-bar--home-opened');
  };

  handleLinkClick = (e) => {
    // const homemenu = $('.home-menu');
    // homemenu.length && homemenu.hasClass('home-menu--opened') && homemenu.toggleClass('home-menu--opened');
    // browserHistory.push(e.target.href);
  };

  render() {

    const fabricator = StonesStore.fabricator();

    return (
      <div className="home">
        <button className="home-button" onClick={this.handleHomeMenuClick}/>
        <div className="home-menu">
          <div className="home-menu-logo">
            <div className="home-menu-logo-house" onClick={this.removeActiveMenu}/>
            <div className="home-menu-logo-vendor" style={{backgroundImage: `url(${fabricator && fabricator.ImageUrl})`}}/>
            {/*https://www.colonialmarble.net/wp-content/uploads/2016/05/logo-sm.jpg*/}
          </div>
          <ul className="home-menu-list">
            {this.props.mainMenu.map((link)=> {
              return (<a href={link.url} className="home-menu__link" target='_top' key={link.id}>
                {link.name}
              </a>)
            })}
          </ul>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/homeButton.js